// extracted by mini-css-extract-plugin
export var option = "_5r-0";
export var optionCard = "_5r-f";
export var optionContent = "_5r-g";
export var optionIcon = "_5r-i";
export var optionIconBox = "_5r-h";
export var optionLabel = "_5r-j";
export var optionPill = "_5r-m";
export var optionPillBadge = "_5r-p";
export var optionPillIcon = "_5r-n";
export var optionPillLabel = "_5r-o";
export var optionRadio = "_5r-k";
export var optionRadioInner = "_5r-l";
export var optionReveal = "_5r-2";
export var optionRevealDelay0 = "_5r-3";
export var optionRevealDelay1 = "_5r-4";
export var optionRevealDelay10 = "_5r-d";
export var optionRevealDelay11 = "_5r-e";
export var optionRevealDelay2 = "_5r-5";
export var optionRevealDelay3 = "_5r-6";
export var optionRevealDelay4 = "_5r-7";
export var optionRevealDelay5 = "_5r-8";
export var optionRevealDelay6 = "_5r-9";
export var optionRevealDelay7 = "_5r-a";
export var optionRevealDelay8 = "_5r-b";
export var optionRevealDelay9 = "_5r-c";
export var optionSelected = "_5r-1";